import React, { createContext, useContext, useState } from "react";

const CompetitorContext = createContext();

export const CompetitorProvider = ({ children }) => {
  const [competitorInfo, setCompetitorInfo] = useState(null);

  return (
    <CompetitorContext.Provider value={{ competitorInfo, setCompetitorInfo }}>
      {children}
    </CompetitorContext.Provider>
  );
};

export const useCompetitorContext = () => {
  return useContext(CompetitorContext);
};
